import React from 'react';
import { AlertTriangle } from 'react-feather';

type DocumentFailedItemProps = {
  document: any;
};

const DocumentFailedItem = ({ document }: DocumentFailedItemProps) => {
  const { filename, error_message } = document;

  return (
    <div className="rounded-lg p-4 border border-red-300 bg-red-50">
      <div className="flex justify-between items-center">
        <div className="flex-1 text-sm text-gray-900 pr-4 break-words">
          {filename}
        </div>
        <div className="flex-shrink-0 flex items-center gap-1.5">
          <AlertTriangle size={14} className="text-red-600" />
          <span className="text-red-600 text-xs leading-4 font-semibold">
            Failed
          </span>
        </div>
      </div>
      <div className="mt-2 text-xs text-red-600">
        {error_message ||
          'Document validation failed. Try selecting a different document.'}
      </div>
    </div>
  );
};

export default DocumentFailedItem;
